import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/settings/user/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/settings/user/profile" });
  },
});
